<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-10">
              <h3 class="mb-0 view-header-buttons">
                {{ equipment.name }}
                <base-button
                  v-if="$currentUserCan($permissions.PERM_EDIT_EQUIPMENTS)"
                  type="primary"
                  icon
                  size="sm"
                  @click="editEquipment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="$currentUserCan($permissions.PERM_DELETE_EQUIPMENTS)"
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteEquipment()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-2 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <equipment-view-global
                    :equipment="equipment"
                    @equipmentUpdated="get"
                  />
                </tab-pane>
                <tab-pane
                  title="files"
                  id="998"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="equipment" />
                </tab-pane>
                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <equipment-view-logs :equipment="equipment" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import { Tabs, TabPane } from "@/components";
import defaultEquipment from "./defaultEquipment";
import EquipmentViewGlobal from "./partials/EquipmentViewGlobal.vue";
import EquipmentViewLogs from "./partials/EquipmentViewLogs.vue";
import formMixin from "@/mixins/form-mixin";
import ListFileComponent from "@/components/File/ListFileComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    EquipmentViewGlobal,
    EquipmentViewLogs,
    ListFileComponent,
  },

  mixins: [formMixin],

  data() {
    return {
      printModalOpened: false,
      equipment: cloneDeep(defaultEquipment),
    };
  },

  computed: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("equipments/get", id);

        this.equipment = this.$store.getters["equipments/equipment"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editEquipment() {
      this.$router.push({
        name: "Edit Equipment",
        params: { id: this.equipment.id },
      });
    },

    async deleteEquipment() {
      const confirmation = await swal.fire({
        title: this.$t("EQUIPMENTS.DELETE_THIS_EQUIPMENT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("equipments/destroy", this.equipment.id);
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("EQUIPMENTS.EQUIPMENT_DELETED"),
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    viewEquipment(equipment) {
      this.$router.push({
        name: "View Equipment",
        params: { id: equipment.id },
      });
    },
    onFormChanged() {
      this.$emit("formChanged");
    },
    goBack() {
      this.$router.push({ name: "List Equipments" });
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
  },
};
</script>
